import putApi from "services/putApi";
import { uploadProfilePicture } from "./UserActions";
import endPoints from "services/endPoints";
import { showToastAction } from "store/slices/commonSlice";
import fileUploadApi from "services/fileUploadApi";
import postApi from "services/postApi";
import getApi from "services/getApi";
import deleteApi from "services/deleteApi";

const uploadDocuments = (file, dispatch, onRes) => async () => {
  const res = await fileUploadApi(endPoints.SINGLE_FILE_UPL, { file: file });
  if (res.success) {
    onRes(res?.data);
  } else {
    dispatch(
      showToastAction({
        type: "error",
        detail: res?.message,
      })
    );
  }
};

const CreateProjectAction =
  (data, writers, setLoading, dispatch, navigate, onRes) => async () => {
    setLoading(true);
    const payload = {
      ...data,
    };

    const writersArray = writers?.map((item) => {
      return { name: item?.name };
    });

    payload.writers = writersArray;

    delete payload.formErrors;
    let licenseAgreementDocument = "";
    if (data?.licenseAgreementDocument) {
      if (typeof data?.licenseAgreementDocument == "object") {
        await dispatch(
          uploadDocuments(
            data?.licenseAgreementDocument,
            dispatch,
            (imgRes) => {
              licenseAgreementDocument = imgRes?.path;
            }
          )
        );
      } else {
        licenseAgreementDocument = data?.licenseAgreementDocument;
      }
    }

    let sampleAgreementDocument = "";
    console.log(data, "data");
    if (data?.sampleAgreementDocument) {
      if (typeof data?.sampleAgreementDocument == "object") {
        await dispatch(
          uploadDocuments(data?.sampleAgreementDocument, dispatch, (imgRes) => {
            sampleAgreementDocument = imgRes?.path;
          })
        );
      } else {
        sampleAgreementDocument = data?.sampleAgreementDocument;
      }
    }

    payload.licenseAgreementDocument = licenseAgreementDocument;
    payload.sampleAgreementDocument = sampleAgreementDocument;

    console.log("payload", payload);

    const res = await postApi(endPoints.PROJECT, payload);

    if (res.success) {
      dispatch(
        showToastAction({
          type: "success",
          detail: res?.message,
        })
      );
      onRes && onRes(res?.data);
      navigate("/project-management");
    } else {
      dispatch(
        showToastAction({
          type: "error",
          detail: res?.message,
        })
      );
    }
    setLoading(false);
  };

const GetProjectListAction =
  (rows, page, search, setIsSearch, dispatch, onRes) => async () => {
    const res = await getApi(
      endPoints.PROJECT_LIST +
        `?limit=${rows}&page=${page}&searchKeys:["projectName"]&searchString=${
          search || ""
        }`
    );
    if (res.success) {
      const options = res?.data?.map((item) => {
        return {
          ...item,
          primaryArtist: item?.writers[0]?.name,
          taskOverview: "6 not started",
        };
      });

      const result = { list: options, count: res?.count };
      onRes && onRes(result);
    } else {
      dispatch(
        showToastAction({
          type: "error",
        })
      );
    }
    setIsSearch(false);
  };

const DeleteProjectAction =
  (id, setLoading, setDeleteModal, dispatch, onRes) => async () => {
    setLoading(true);
    const res = await deleteApi(endPoints.PROJECT + `/${id}`);
    if (res.success) {
      dispatch(
        showToastAction({
          type: "success",
          detail: res?.message,
        })
      );
      onRes && onRes();
    } else {
      dispatch(
        showToastAction({
          type: "error",
          detail: res?.message,
        })
      );
    }
    setLoading(false);
    setDeleteModal(false);
  };

const GetProjectDetailsActon = (id, dispatch, onRes) => async () => {
  const res = await getApi(endPoints.PROJECT + `/${id}`);
  if (res.success) {
    onRes && onRes(res?.data);
  } else {
    dispatch(
      showToastAction({
        type: "success",
        detail: res?.message,
      })
    );
  }
};

const UpdateProjectAction =
  (id, data, writers, setLoading, dispatch, navigate, onRes) => async () => {
    setLoading(true);
    const payload = {
      ...data,
    };

    const writersArray = writers?.map((item) => {
      return { name: item?.name };
    });

    payload.writers = writersArray;

    delete payload.formErrors;
    let licenseAgreementDocument = "";
    console.log(
      "data?.licenseAgreementDocument",
      data?.licenseAgreementDocument
    );
    if (data?.licenseAgreementDocument) {
      if (typeof data?.licenseAgreementDocument == "object") {
        await dispatch(
          uploadDocuments(
            data?.licenseAgreementDocument,
            dispatch,
            (imgRes) => {
              licenseAgreementDocument = imgRes?.path;
            }
          )
        );
      } else {
        licenseAgreementDocument = data?.licenseAgreementDocument;
      }
    }

    let sampleAgreementDocument = "";
    console.log(data, "data");
    if (data?.sampleAgreementDocument) {
      if (typeof data?.sampleAgreementDocument == "object") {
        await dispatch(
          uploadDocuments(data?.sampleAgreementDocument, dispatch, (imgRes) => {
            sampleAgreementDocument = imgRes?.path;
          })
        );
      } else {
        sampleAgreementDocument = data?.sampleAgreementDocument;
      }
    }

    if (licenseAgreementDocument) {
      payload.licenseAgreementDocument = licenseAgreementDocument;
    }

    if (sampleAgreementDocument) {
      payload.sampleAgreementDocument = sampleAgreementDocument;
    }

    const res = await putApi(endPoints.PROJECT + `/${id}`, payload);

    if (res.success) {
      dispatch(
        showToastAction({
          type: "success",
          detail: res?.message,
        })
      );
      onRes && onRes(res?.data);
      navigate("/project-management");
    } else {
      dispatch(
        showToastAction({
          type: "error",
          detail: res?.message,
        })
      );
    }
    setLoading(false);
  };

const toogleFavroiteAction =
  (data, setLoading, navigate, dispatch, onRes) => async () => {
    setLoading(true);
    const payload = {
      ...data,
    };
    const res = await postApi(endPoints.FAVROITE_PROJECT, payload);

    if (res.success) {
      dispatch(
        showToastAction({
          type: "success",
          detail: res?.message,
        })
      );
      onRes && onRes(res?.data);
      navigate("/dashboard");
    } else {
      dispatch(
        showToastAction({
          type: "error",
          detail: res?.message,
        })
      );
      setLoading(false);
    }
  };

const uploadAgreementAction =
  (data, setLoading, dispatch, onRes) => async () => {
    console.log("uploadAgreementAction", data);
    try {
      setLoading(true);

      const { file, projectId, agreementName } = data;
      let filePath = "";

      if (file && typeof file === "object") {
        console.log("Uploading file...");

        const uploadResult = await new Promise((resolve, reject) => {
          dispatch(
            uploadDocuments(file, dispatch, (res) => {
              if (res?.path) {
                resolve(res.path);
              } else {
                reject("Failed to get path from upload");
              }
            })
          );
        });

        filePath = uploadResult;
      } else {
        filePath = file;
      }

      const payload = {
        projectId,
        agreementName,
        file: filePath, 
      };

      console.log("payload", payload);

      const res = await putApi(endPoints.UPLOAD_AGREEMENT, payload);

      if (res.success) {
        dispatch(
          showToastAction({
            type: "success",
            detail: res.message || "Agreement uploaded successfully",
          })
        );
        onRes?.(res);
      } else {
        dispatch(
          showToastAction({
            type: "error",
            detail: res.message || "Failed to save agreement",
          })
        );
      }
    } catch (error) {
      console.error("Error in uploadAgreementAction", error);
      dispatch(
        showToastAction({
          type: "error",
          detail: "Something went wrong",
        })
      );
    } finally {
      setLoading(false);
    }
  };



export {
  uploadDocuments,
  CreateProjectAction,
  GetProjectListAction,
  DeleteProjectAction,
  GetProjectDetailsActon,
  UpdateProjectAction,
  toogleFavroiteAction,
  uploadAgreementAction,
};
